module.exports = __webpack_public_path__ + "img-dashboard/register/ic-breadcrumb-webcv-blue.6891c1c7.svg";